import { render, staticRenderFns } from "./platformHouseholdEdit.vue?vue&type=template&id=53097e46&scoped=true"
import script from "./platformHouseholdEdit.vue?vue&type=script&lang=js"
export * from "./platformHouseholdEdit.vue?vue&type=script&lang=js"
import style0 from "./platformHouseholdEdit.vue?vue&type=style&index=0&id=53097e46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53097e46",
  null
  
)

export default component.exports